import { authorizedGetRequest } from '@/api/requests';

const GLOBALSETTINGS = 'globalsettings';
const getRegions = () =>
  authorizedGetRequest(`${GLOBALSETTINGS}/regions`, {
    regionsApi: true,
    preventCancelRequest: true,
  });

export default {
  getRegions,
};
